import { render, staticRenderFns } from "./GitHub.vue?vue&type=template&id=1635735a&"
import script from "./GitHub.vue?vue&type=script&lang=js&"
export * from "./GitHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1635735a')) {
      api.createRecord('1635735a', component.options)
    } else {
      api.reload('1635735a', component.options)
    }
    module.hot.accept("./GitHub.vue?vue&type=template&id=1635735a&", function () {
      api.rerender('1635735a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/GitHub.vue"
export default component.exports